/**
 * Asking for an App Store rating, rarely and at a happy moment: only in the iPhone app, once
 * someone has used Nameling on at least two different days and decided on 40 names, and at most
 * once per version of the app. iOS itself shows the prompt no more than three times a year, and
 * never to someone who has already rated.
 */
import { decisions, native } from "./app";
import { count } from "./telemetry";
import { saveRaw } from "./store";

const KEY = "nameling:review";

interface Visits {
  /** the last day the app was opened (YYYY-MM-DD) */
  last: string;
  /** how many different days it has been opened on */
  days: number;
  /** the build that last asked */
  asked: string;
}

function read(): Visits {
  try {
    return { last: "", days: 0, asked: "", ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    return { last: "", days: 0, asked: "" };
  }
}

function write(v: Visits): void {
  saveRaw(KEY, JSON.stringify(v));
}

/** Note today's visit (call once when the app opens). */
export function noteVisit(): void {
  const today = new Date().toISOString().slice(0, 10);
  const v = read();
  if (v.last !== today) write({ ...v, last: today, days: v.days + 1 });
}

/** A good moment (a shortlist milestone, or a match): ask, if it's time. */
export function maybeAskForReview(): void {
  if (!native.requestReview) return;
  const v = read();
  const build = typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : "dev";
  if (v.days < 2 || v.asked === build || Object.keys(decisions.get().map).length < 40) return;
  write({ ...v, asked: build });
  count("review.asked");
  // once the celebration has had its moment
  window.setTimeout(() => native.requestReview?.(), 1800);
}
